import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { api } from '@/services/api.service';

import gameSlice from '@/store/slices/game.slice';
import pickemSlice from '@/store/slices/pickem.slice';

const rootReducer = combineReducers({
  pickem: pickemSlice,
  game: gameSlice,
  [api.reducerPath]: api.reducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

export const selectPickem = (state: RootState) => state.pickem;
export const selectGameStore = (state: RootState) => state.game;
